export default {
    baseStyle: {
        checkboxStyle: {
            alignItems: 'start',
            '.chakra-checkbox__control': {
                marginTop: '0.4rem',
                _invalid: {
                    borderColor: 'red.550',
                    bg: 'red.750',
                    color: 'red.550'
                }
            }
        },
        checkboxText: {
            fontSize: 'sm',
            color: 'gray.700'
        },
        buttonStyle: {
            w: 'auto',
            marginTop: '2rem'
        },
        checkboxError: {
            fontSize: '12px',
            color: 'red.550',
            position: 'absolute',
            top: '100%',
            left: '0%'
        },
        title: {
            fontFamily: 'UniversLTStd, Arial, sans-serif',
            fontSize: {base: '14px', sm: '18px'},
            color: 'black',
            textTransform: 'uppercase',
            lineHeight: {base: '18px', sm: 'unset'},
            border: 'none!important'
        },
        edit: {
            color: 'gray.550',
            background: 'none',
            height: '100%',
            padding: 0,
            fontSize: {base: '12px', sm: '14px'},
            fontWeight: 400,
            display: 'flex',
            alignItems: 'center',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
            _hover: {
                textDecoration: 'underline',
                color: 'gray.550'
            },
            _active: {
                background: 'none'
            },
            _focus: {
                background: 'none',
                boxShadow: 'none'
            }
        },
        heading: {
            fontFamily: 'UniversLTStd, Arial, sans-serif',
            fontSize: {base: '14px', sm: '18px'},
            fontWeight: 600
        },
        otherBillingCheck: {
            fontSize: {base: '12px', sm: '14px'},
            fontWeight: 600,
            textDecoration: 'underline',
            cursor: 'pointer'
        }
    }
}
